import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useSelector, useDispatch } from "react-redux";
import {
  TOGGLE_GROWING_LIST_POPUP,
  SET_ORGANISATION_DROPDOWN_VALUES,
  SET_EMPLOYEE_DROPDOWN_VALUES,
  GLOBAL_DATA,
} from "../../Redux/actions";
import DataService from "../../Service";
import { useParams } from "react-router";
import { showSnackbar } from "../Snackbar/SnackbarActions";
import { SetGdprError } from "../../Pages/Roles/Admin/Employee/Create/Gdpr/GdprActions";

export default function FormDialog(props) {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(props.show);
  const [newValue, setNewvalue] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [alreadyAddedFlag, setAlreadyAddedFlag] = useState("");

  const params = useParams();
  const { id } = params;
  const { showGrowingDropdownModal } = useSelector(
    (state) => state.commonReducer
  );

  useEffect(() => {
    // console.log(props)
  }, [props.postData]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    // setOpen(false);
    if (
      props.type === "organization" ||
      props.type === "all_employee_dropdowns"
    ) {
      props.setShowModal(false);
    }
    setLoading(false);

    dispatch({ type: TOGGLE_GROWING_LIST_POPUP, payload: false });
  };

  const handleInputChange = (value) => {
    setNewvalue(value);
  };

  const global_data_common = useSelector((state) => state.commonReducer);
  const handleSubmit = () => {
    if (newValue.length === 0) {
      setError(true);
      return;
    }
    // console.log(props, newValue, 'submitt')
    setLoading(true);
    const { drop_down, field_name, magic20_field_id } = props.postData;

    DataService.createData(
      {
        drop_down: drop_down,
        field_name: field_name,
        value: newValue,
        magic20_field_id,
      },
      "add_in_drop_down"
    )
      .then((result) => {
        setLoading(false);

        // if (props.type == "partner_profiles") {
        //   DataService.getData({}, props.type)
        //     .then((response) => {
        //       dispatch({ type: GLOBAL_DATA, payload: { partnerDropdowns: response } })
        //       setTimeout(() => {

        //         props.postData.parentcall(newValue, props.postData.id, "add_in_drop_down")
        //       }, 1000);
        //       setLoading(false);
        //     })
        //     .catch((err) => { setLoading(false) });
        // }
        if (props.type === "partner_profiles") {
          DataService.getData({}, props.type)
            .then((response) => {
              dispatch({
                type: GLOBAL_DATA,
                payload: { partnerDropdowns: response },
              });
              setTimeout(() => {
                console.log(
                  "global_data_common timedout",
                  global_data_common.partnerDropdowns
                );
                props.postData.parentcall(
                  newValue,
                  props.postData.id,
                  "add_in_drop_down",
                  result?.id
                );
              }, 1000);
              console.log("adding new value from addtolist", newValue);
              props.postData.setValueAdded({ added: true, value: newValue });
              setLoading(false);
            })
            .catch((err) => {
              setLoading(false);
            });
        } else if (props.type === "organization") {
          let params = {};
          if (props.orgParams) {
            params = props.orgParams;
          }
          DataService.getData(params, "all_organisation_dropdowns")
            .then((response) => {
              setLoading(false);
              props.setShowModal(false);
              dispatch({
                type: SET_ORGANISATION_DROPDOWN_VALUES,
                payload: response,
              });
              dispatch(
                showSnackbar(
                  "success",
                  drop_down === "Service"
                    ? ["New service added successfully"]
                    : ["New value added successfully"]
                )
              );
              props.handleAddNewValue(newValue, result?.id);
            })
            .catch((err) => {});
        } else {
          DataService.getData({ organisation_id: id }, "all_employee_dropdowns")
            .then((response) => {
              setLoading(false);
              props.setShowModal(false);
              dispatch({
                type: SET_EMPLOYEE_DROPDOWN_VALUES,
                payload: response,
              });
              dispatch(
                showSnackbar("success", ["New value added successfully!"])
              );
              props.handleAddNewValue(newValue, result?.id);
            })
            .catch((err) => {});
        }
        setLoading(false);
        handleClose();
      })
      .catch((err) => {
        console.log("first", err);
        dispatch(showSnackbar("error", [["" + err.errors]]));
        // setAlreadyAddedFlag(err.errors[0])
        setLoading(false);

        // handleClose();
        // alert("Internal server error")
      });
  };

  return (
    <div>
      <Dialog
        fullWidth
        open={showGrowingDropdownModal}
        onClose={handleClose}
        style={{ zIndex: "1305" }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Add New Value</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* To subscribe to this website, please enter your email address here. We will send updates
            occasionally. */}
          </DialogContentText>
          <TextField
            autoFocus
            required
            variant="outlined"
            margin="dense"
            id="newValue"
            // label="Enter New Value"
            // type="email"
            fullWidth
            autoComplete="off"
            onChange={(e) => {
              handleInputChange(e.target.value);
              setError(false);
            }}
          />
          {error && <span className="helperText">* Please enter a value</span>}
          {alreadyAddedFlag != "" && (
            <span className="helperText">* {alreadyAddedFlag}</span>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            disableElevation
            onClick={handleClose}
            color="primary"
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            disableElevation
            disabled={loading}
            onClick={handleSubmit}
            color="secondary"
            style={{ textTransform: "none" }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
